import { clearCookies, clearStorages, signOut } from "../auth/utils";
import { useAuthContext } from "../context/AuthContext";

const useLog = () => {
  const auth = useAuthContext();

  const log = (message) => {
    process.env.REACT_APP_BASE_URL.includes("dev") && console.log(message);
  };

  const extendedLog = (message, className, functionName) => {
    process.env.REACT_APP_BASE_URL.includes("dev") &&
      console.log(`[${className}.js] - ${functionName} => `, message);
  };

  const errorLog = async (error, className, functionName, queryName) => {
    const errorMessage = error?.message || error;
    if (process.env.REACT_APP_BASE_URL.includes("dev")) {
      console.error(
        `[${className}.js] - ${functionName} ${queryName} Error => `,
        JSON.stringify(errorMessage)
      );
    }

    if (
      JSON.stringify(errorMessage)
        ?.toLowerCase()
        ?.includes("token is required") ||
      JSON.stringify(errorMessage)
        ?.toLowerCase()
        ?.includes("token verification error") ||
      JSON.stringify(errorMessage)?.toLowerCase()?.includes("token expired") ||
      JSON.stringify(errorMessage)?.toLowerCase()?.includes("unauthorized") ||
      JSON.stringify(errorMessage)?.toLowerCase()?.includes("invalid token") ||
      JSON.stringify(errorMessage)?.toLowerCase()?.includes("not valid user")
    ) {
      // Messenger is optional; its absence/failure must not interrupt logout.
      try {
        if (typeof window.Intercom === "function") window.Intercom("shutdown");
      } catch (_) { /* Continue Manager authentication cleanup. */ }

      try {
        // Sign out from Firebase
        await signOut();

        // clear lS and SS
        clearStorages();

        // clear cookies
        clearCookies();

        // Perform logout via auth context
        auth.logout();
      } catch (error) {
        console.error("Error during logout:", error);
      }
    }
  };

  return { log, extendedLog, errorLog };
};

export default useLog;
